import React, { useEffect } from 'react';
import { Modal, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import useMachineForm from "./useMachineForm";
import { createMachine } from '../../../redux/Machine/actions';
import { fetchCountries } from '../../../redux/Country/actions';
import MachineForm from "./MachineForm";

export const AddMachineButton = ({ users }) => {
  const dispatch = useDispatch();
  const { form, visible, showModal, hideModal_Ok, hideModal_Cancel, form_onFinish } = useMachineForm(
    {
      machinename: '',
      machineid: '',
      user: '',
      country: '',
      islinkedPC: false,
      idpc: '',
      keypc: '',
      isActive: true,
    },
    (values) => dispatch(createMachine(values)),
    'add'
  );

  // Fetch countries when the component mounts
  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const countries = useSelector((state) => state.countries?.countries || []);

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Create
      </Button>
      <Modal
        title="Add Machine"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Save"
        cancelText="Cancel"
      >
        <MachineForm form={form} users={users} countries={countries} onFinish={form_onFinish} />
      </Modal>
    </>
  );
};

export default AddMachineButton;
